export default "__VITE_ASSET__CJVzmYgb__"